import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Add script for interactive elements
document.addEventListener('DOMContentLoaded', function() {
  // Service Cards Expansion
  const serviceCards = document.querySelectorAll('.service-card');
  
  serviceCards.forEach(card => {
    const expandButton = card.querySelector('.expand-button');
    const fullContent = card.querySelector('.full-content');
    
    if (expandButton && fullContent) {
      expandButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isExpanded = card.classList.contains('expanded');
        
        // Close any open cards first
        document.querySelectorAll('.service-card.expanded').forEach(openCard => {
          if (openCard !== card) {
            openCard.classList.remove('expanded');
            
            const fullContentElem = openCard.querySelector('.full-content') as HTMLElement;
            const expandButtonElem = openCard.querySelector('.expand-button') as HTMLElement;
            const expandIconElem = openCard.querySelector('.expand-icon') as HTMLElement;
            
            if (fullContentElem) {
              fullContentElem.style.maxHeight = '0px';
            }
            
            if (expandButtonElem) {
              expandButtonElem.setAttribute('aria-expanded', 'false');
            }
            
            if (expandIconElem) {
              expandIconElem.classList.remove('rotate-180');
            }
          }
        });
        
        // Toggle current card
        card.classList.toggle('expanded');
        
        if (!isExpanded) {
          (fullContent as HTMLElement).style.maxHeight = `${(fullContent as HTMLElement).scrollHeight}px`;
          expandButton.setAttribute('aria-expanded', 'true');
          
          const expandIcon = expandButton.querySelector('.expand-icon');
          if (expandIcon) {
            expandIcon.classList.add('rotate-180');
          }
        } else {
          (fullContent as HTMLElement).style.maxHeight = '0px';
          expandButton.setAttribute('aria-expanded', 'false');
          
          const expandIcon = expandButton.querySelector('.expand-icon');
          if (expandIcon) {
            expandIcon.classList.remove('rotate-180');
          }
        }
      });
    }
  });
  
  // Scroll Animation for Service Cards
  const animateOnScroll = function() {
    const elements = document.querySelectorAll('.animate-on-scroll');
    
    elements.forEach(element => {
      const elementPosition = element.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      
      if (elementPosition < windowHeight - 100) {
        element.classList.add('animated');
      }
    });
  };
  
  // Run once on page load
  animateOnScroll();
  
  // Run on scroll
  window.addEventListener('scroll', animateOnScroll);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
